import { t, tf } from "./i18n.js";
// Der Supabase-Client wird in src/main.js aus den VITE_-Umgebungsvariablen
// erzeugt und liegt dort bereits als window._supabase bereit, bevor diese
// Datei ausgefuehrt wird.

window.botSvg = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="vertical-align: middle; margin-right: 5px;"><rect x="3" y="11" width="18" height="10" rx="2"></rect><circle cx="12" cy="5" r="2"></circle><path d="M12 7v4"></path><line x1="8" y1="16" x2="8.01" y2="16"></line><line x1="16" y1="16" x2="16.01" y2="16"></line></svg>`;

// ==========================================
// GLOBALE DART-KONSTANTEN
// ==========================================
window.targets = [
  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 25, 50,
];

// Die echte Reihenfolge auf einem Dartboard (im Uhrzeigersinn, startend bei 20)
window.UNIVERSAL_BOARD_ORDER = [
  20, 1, 18, 4, 13, 6, 10, 15, 2, 17, 3, 19, 7, 16, 8, 11, 14, 9, 12, 5,
];
window.players = [];
window.currentPlayerIndex = 0;
window.globalTargetIndex = 0;
window.isTrainingMode = false;
// Kurzmodus (10-Bull): Secure-Leiter startet erst bei der 10
window.isShortMode = false;
window.statsChart = null;
window.currentModalPlayer = "";
window.gameHistoryStack = [];
window.botTimer = null;
let currentStatsMode = "secure";

window.currentRawScore = 0;
window.secureMultiplier = 0;
window.isSecured = false;
window.isDoubleHit = false;
window.thrownScore = 0;
window.thrownSecure = 0;
window.MAX_DARTS = 3;

window.currentAppMode = "";
window.currentUser = null;
window.isGuest = false;
let pendingCancelAction = null;

window.myOnlineName = "";
window.currentRoomCode = "";
window.realtimeSubscription = null;
window.amIPlayer1 = false;
window.isMyTurn = false;
window.current501Input = "";
window.isLocal501 = false;
window.localP1Name = t("js.app.001");
window.localP2Name = t("js.app.002");
window.localP1Score = 501;
window.localP2Score = 501;
window.localCurrentTurn = 1;
window.bestOfLegs = 3;
// FIX: startingScore501 war NIRGENDS deklariert. Im alten Skript-Modus
// entstand die Variable implizit beim ersten Zuweisen. ES-Module laufen im
// Strict Mode - dort wirft genau das eine ReferenceError. Wird in
// game-501.js (19x) und friends.js (2x) verwendet.
window.startingScore501 = 501;
window.localP1Legs = 0;
window.localP2Legs = 0;
window.p1TotalScore = 0;
window.p2TotalScore = 0;
window.p1LastThrow = "-";
window.p2LastThrow = "-";
window.p1Darts501 = 0;
window.p2Darts501 = 0;
window.currentMatchLog501 = [];
window.p1DartsAtLegStart = 0;
window.p2DartsAtLegStart = 0;
window.history501Stack = [];
// Ur-Zustand des Stats-Trackers. Die MASSGEBLICHE Feldliste wohnt in
// game-501.js (statsFelder/resetStatsTracker) - diese Kopie hier existiert
// nur, damit die Variable vor dem ersten Spielstart nicht undefined ist.
//
// Alpha-Befund 13.08.2026: Diese Kopie war veraltet (scoreFrequencies,
// highestFinish, first9Score/first9Darts fehlten). Der Reconnect-Pfad
// unten (reconnectToRunningGames) startete das Online-Spiel, OHNE
// resetStatsTracker() aufzurufen - der erste Wurf crashte dann in
// submit501Score bei pStats.scoreFrequencies[x], und JEDER Wurf schlug
// mit "Wurf konnte nicht verarbeitet werden" fehl. Beide Stellen sind
// repariert; sollte die Form erneut wachsen, faengt zusaetzlich
// ergaenzeStatsFelder() in game-501.js fehlende Felder ab.
window.statsTracker = {
  p1: {
    dartsCurrentLeg: 0,
    bestLeg: 0,
    highestFinish: 0,
    t100: 0,
    t140: 0,
    t180: 0,
    busts: 0,
    checkoutAttempts: 0,
    checkoutHits: 0,
    scoreFrequencies: {},
    first9Score: 0,
    first9Darts: 0,
  },
  p2: {
    dartsCurrentLeg: 0,
    bestLeg: 0,
    highestFinish: 0,
    t100: 0,
    t140: 0,
    t180: 0,
    busts: 0,
    checkoutAttempts: 0,
    checkoutHits: 0,
    scoreFrequencies: {},
    first9Score: 0,
    first9Darts: 0,
  },
};

// ==========================================
// DRY HELPER LOGIK (Bildschirm-Steuerung)
// ==========================================
window.ALL_SCREENS = [
  "auth-screen",
  "home-screen",
  "secure-setup-screen",
  "game-secure-screen",
  "online-lobby-screen",
  "game-501-screen",
  "secure-rules-screen",
  "party-setup-screen",
  "game-party-screen",
  "bobs-setup-screen",
  "game-bobs-screen",
  "rtw-setup-screen",
  "game-rtw-screen",
  "secure-lobby-screen",
  "profile-screen",
  "setup-121-screen",
  "game-121-screen",
  "cricket-setup-screen",
  "game-cricket-screen",
  "random-setup-screen",
  "game-random-screen",
  "open-lobbies-screen",
  "gotcha-setup-screen",
  "game-gotcha-screen",
  "scoring-training-screen",
  // Refactor 07.08.2026 (Schritte 2/3): highscore-screen und settings-screen
  // sind eigene Seiten (stats.html, einstellungen.html) und keine
  // Shell-Screens mehr.
];

// FIX: Namen mit Komma oder Anfuehrungszeichen haben den .or()-Filterausdruck
// von PostgREST zerlegt. Beides wird jetzt entschaerft.
function escapePgFilter(value) {
  return String(value == null ? "" : value)
    .replace(/\\/g, "")
    .replace(/"/g, "")
    .replace(/,/g, " ");
}

function hideAllScreens() {
  ALL_SCREENS.forEach((s) => {
    let el = document.getElementById(s);
    if (el) el.style.display = "none";
  });
}

// Universeller Setup-Opener für Minigames
// ---------------------------------------------------------------------------
// Einen Bildschirm einblenden - mit der Anzeigeart, die er braucht.
//
// Vorher stand hier ueberall fest "block". Ein Inline-Style schlaegt aber
// jede Regel im Stylesheet, also blieben die Setup-Bildschirme Block-
// Container, obwohl style.css sie als Flex-Spalte definiert. Folge: Das
// Raster konnte den freien Platz nicht aufnehmen und die Aktionsleiste
// sass bei jedem Modus auf einer anderen Hoehe - genau der Fehler, der
// sich ueber mehrere Anlaeufe gehalten hat.
// ---------------------------------------------------------------------------
// Von der Secure-Einrichtung zu den Spielregeln. Vorher stand die
// Umschaltung als mehrzeiliges onclick im HTML - schlecht lesbar und
// nicht wiederverwendbar.
function switchToSecureRules() {
  const setup = document.getElementById("secure-setup-screen");
  const rules = document.getElementById("secure-rules-screen");
  if (setup) setup.style.display = "none";
  showScreenElement(rules);
}

function showScreenElement(el) {
  if (!el) return;
  // "screen-flex" ist fuer Huellen wie online-lobby-screen, die selbst
  // kein Setup sind, aber einen Setup-Bildschirm enthalten. Ohne sie
  // bricht die Hoehenkette und der Zurueck-Knopf sitzt dort tiefer.
  const flex =
    el.classList.contains("setup-screen") || el.classList.contains("screen-flex");
  el.style.display = flex ? "flex" : "block";
}

// ==========================================
// MODUS-REGISTER: Spielen oder Training? (15.08.2026)
//
// Dieselbe Trennung, die das Hauptmenue zeigt - und dieselbe, die in der
// Datenbank landet. Bis hierher setzte NUR der Secure-Haken "Separat
// speichern" das Feld `is_training`; in allen anderen Modi blieb es false,
// obwohl Bob's 27 und Round the World nichts anderes sind als Training.
// Der Heatmap-Filter (Training | Match) und die Markierung im Profil waren
// damit auf einen einzigen Haken in einem einzigen Modus angewiesen.
//
// Jetzt haengt die Auskunft am MODUS, nicht an einer Bedienentscheidung:
// Sie kann nicht vergessen werden, und sie kann nicht falsch gesetzt
// werden. Das Hauptmenue traegt dieselbe Zuordnung in `data-gruppe` - wer
// eine Kachel verschiebt, sieht hier die zweite Stelle.
//
// ACHTUNG bei neuen Modi: Wer hier fehlt, gilt als "spielen" (kein
// Training). Das ist die harmlosere Vorgabe - ein Match faelschlich als
// Training zu zaehlen verfaelscht die Statistik, andersherum fehlt nur ein
// Filtertreffer.
// ==========================================
const MODUS_GRUPPE = {
  // Spielen
  secure: "spielen",
  501: "spielen",
  party: "spielen",
  gotcha: "spielen",
  cricket: "spielen",
  // Training
  bobs: "training",
  rtw: "training",
  121: "training",
  random: "training",
  scoring: "training",
  // Kein Spielmodus, sondern der Anwurf vor einem Match - er darf die
  // Trainingsmarke des laufenden Modus nicht ueberschreiben.
  bulloff: null,
};

/** Ist dieser Modus ein Trainingsmodus? Unbekannt = nein (s. oben). */
function istTrainingsModus(modus) {
  return MODUS_GRUPPE[modus] === "training";
}

/** `currentAppMode` setzen UND die Trainingsmarke daraus ableiten.
 *
 *  Eine Stelle statt zweier: Wer den Modus wechselt, kann die Marke nicht
 *  vergessen. `null` (bulloff) laesst beides unangetastet. */
function setzeAppModus(modus) {
  if (!modus) return;
  window.currentAppMode = modus;
  if (MODUS_GRUPPE[modus] !== null) {
    window.isTrainingMode = istTrainingsModus(modus);
  }
}

/**
 * Universeller Setup-Opener fuer die Minigames.
 *
 * @param {string} screenId  Setup-Bildschirm
 * @param {string} title     nur Beschriftung
 * @param {?string} inputId  Namensfeld, wird vorbelegt
 * @param {?string} modus    Schluessel in window.autoScoreAdapter
 *
 * BEFUND 14.08.2026 - der vierte Parameter ist der eigentliche Grund fuer
 * diese Zeilen: `currentAppMode` wurde bisher NUR von 501, Secure und
 * Scoring gesetzt. Fuer Bob's, RTW, Catch 121, Gotcha, Random, Party und
 * Cricket blieb er "". autoscore.js schlaegt den Adapter aber genau darueber
 * nach (`window.autoScoreAdapter[currentAppMode || "501"]`) - und landete
 * damit beim 501-Adapter, dessen aktiv() auf einem fremden Bildschirm false
 * ist. Ergebnis: In sieben von neun Modi hat der Tracker NICHTS getan,
 * obwohl die Adapter da waren. Zusaetzlich schrieb queueThrowRows() die
 * Heatmap-Wuerfe unter mode "501" weg.
 */
function openGameSetup(screenId, title, inputId = null, modus = null) {
  hideAllScreens();
  const screen = document.getElementById(screenId);
  showScreenElement(screen);

  // Schon im Setup setzen, nicht erst beim Spielstart: Der Trackerkasten
  // wandert ueber render() an die Zielstelle des Adapters, und das passiert
  // beim naechsten Ereignis - nicht erst, wenn jemand "Start" drueckt.
  if (modus) {
    setzeAppModus(modus);
    window.autoScore?.render?.();
  }

  if (inputId) {
    let inputEl = document.getElementById(inputId);
    if (inputEl) inputEl.value = myOnlineName || t("js.app.009");
  }

  // Namensfelder mit dem Login-Namen belegen und im Solo-Modus das
  // Eingabefeld durch die Namensanzeige ersetzen.
  if (typeof applyPlayerNameDefaults === "function") applyPlayerNameDefaults();
}

// ==========================================
// INITIALISIERUNG & NAVIGATION
// ==========================================
async function initAuth() {
  const {
    data: { session },
  } = await _supabase.auth.getSession();
  if (session) {
    currentUser = session.user;
    isGuest = false;
    initPresence();
    if (typeof initNotifications === "function") initNotifications();
    showMainApp();
  } else {
    showAuthScreen();
  }
}

// Der Freunde-Dock lebt ausserhalb des main-containers und haengt deshalb
// nicht an hideAllScreens() - er wird nur an Login/Logout gekoppelt.
function setFriendsDockVisible(visible) {
  const dock = document.getElementById("home-friends-panel");
  if (dock) dock.style.display = visible ? "flex" : "none";
}

function showAuthScreen() {
  document.getElementById("top-header").style.display = "none";
  document.getElementById("main-container").style.display = "none";
  setFriendsDockVisible(false);
  hideAllScreens();
  document.getElementById("auth-screen").style.display = "block";
}

async function showMainApp() {
  document.getElementById("auth-screen").style.display = "none";
  document.getElementById("top-header").style.display = "block";
  // "flex", nicht "block": Der Container ist im Stylesheet eine Spalte,
  // damit der aktive Bildschirm die volle Hoehe einnehmen kann. Ein
  // Inline-Style wuerde die Regel sonst aushebeln.
  document.getElementById("main-container").style.display = "flex";
  document.getElementById("secure-setup-screen").style.display = "none";

  // Dock schon hier einblenden - der Reconnect-Pfad unten verlaesst die
  // Funktion vor goHome(), der Dock soll aber auch dann sichtbar sein.
  setFriendsDockVisible(true);
  if (typeof refreshHomeFriendsPanel === "function") refreshHomeFriendsPanel();
  // Nach dem Login sofort anbieten, was vom letzten Besuch uebrig ist
  // (spielwache.js, 29.08.2026).
  if (typeof aktualisiereFortsetzenKachel === "function") {
    aktualisiereFortsetzenKachel();
  }

  let displayName = "";
  if (!isGuest && currentUser) {
    displayName =
      currentUser.user_metadata?.display_name ||
      currentUser.user_metadata?.full_name ||
      currentUser.email.split("@")[0];
    myOnlineName = displayName;
    let { data: myProfile } = await _supabase
      .from("profiles")
      .select("avatar_url")
      .eq("id", currentUser.id)
      .maybeSingle();

    if (myProfile && myProfile.avatar_url) {
      if (!currentUser.user_metadata) currentUser.user_metadata = {};
      currentUser.user_metadata.avatar_url = myProfile.avatar_url;
    }

    await _supabase.from("profiles").upsert(
      {
        id: currentUser.id,
        name: myOnlineName,
        avatar_url: currentUser.user_metadata?.avatar_url || null,
      },
      { onConflict: "id" },
    );

    // 3. Inputs im Menü befüllen
    let p1Input = document.getElementById("local-p1-name");
    let onlineInput = document.getElementById("online-player-name");
    if (p1Input) p1Input.value = displayName;
    if (onlineInput) onlineInput.value = displayName;

    // Alle uebrigen Namensfelder gleich mitziehen
    if (typeof applyPlayerNameDefaults === "function") applyPlayerNameDefaults();
  }

  if (!isGuest && myOnlineName) {
    // ---> Veraltete Spiele (älter als 4 Stunden) gnadenlos löschen <---
    const fourHoursAgo = new Date(
      Date.now() - 4 * 60 * 60 * 1000,
    ).toISOString();
    await _supabase
      .from("live_matches")
      .delete()
      .or(
        `player1_name.eq."${escapePgFilter(myOnlineName)}",player2_name.eq."${escapePgFilter(myOnlineName)}"`,
      )
      .lt("created_at", fourHoursAgo); // lt = less than (älter als)

    // Dasselbe fuer Secure-Online: verwaiste Lobbys (Host hat den Tab
    // geschlossen) blieben sonst dauerhaft in der Lobby-Liste stehen.
    await _supabase
      .from("live_secure_matches")
      .delete()
      .eq("host_name", myOnlineName)
      .lt("created_at", fourHoursAgo);

    // FIX: maybeSingle() wirft einen Fehler, sobald mehr als eine Zeile passt.
    // Mit order+limit(1) bekommt man immer das juengste offene Match.
    let { data: room, error } = await _supabase
      .from("live_matches")
      .select("*")
      .or(
        `player1_name.eq."${escapePgFilter(myOnlineName)}",player2_name.eq."${escapePgFilter(myOnlineName)}"`,
      )
      .in("status", ["waiting", "playing", "leg_won"])
      .order("created_at", { ascending: false })
      .limit(1)
      .maybeSingle();

    if (room) {
      console.log(t("js.app.011"));
      currentRoomCode = room.room_code;
      amIPlayer1 = room.player1_name === myOnlineName;
      isLocal501 = false;
      currentAppMode = "501";

      // Alpha-Befund 13.08.2026: Dieser Pfad startete das Spiel, ohne den
      // Stats-Tracker aufzusetzen - es blieb der veraltete Ur-Zustand von
      // oben, und submit501Score crashte bei jedem Wurf (TypeError auf
      // scoreFrequencies). Die Leg-Statistik ist nach einem Neuladen
      // ohnehin nicht rekonstruierbar; ein sauberer Reset ist hier die
      // ehrliche Variante.
      if (typeof window.resetStatsTracker === "function") {
        window.resetStatsTracker();
      }

      document.getElementById("home-screen").style.display = "none";
      document.getElementById("online-lobby-screen").style.display = "none";
      showScreenElement(document.getElementById("game-501-screen"));

      sync501UI(room);
      listenForOpponent(currentRoomCode);
      return;
    }

    // Reconnect fuer Secure-Online (Befund #6, PRUEFBERICHT_ONLINE.md):
    // analog zu 501 - laufende oder wartende Raeume mit eigenem Namen
    // wieder aufnehmen, statt den Gegner in einem toten Raum sitzen
    // zu lassen. Der 4h-Cleanup oben hat Altlasten schon entfernt.
    let { data: secureRoom } = await _supabase
      .from("live_secure_matches")
      .select("*")
      .or(
        `host_name.eq."${escapePgFilter(myOnlineName)}",guest_name.eq."${escapePgFilter(myOnlineName)}"`,
      )
      .in("status", ["waiting", "playing"])
      .order("created_at", { ascending: false })
      .limit(1)
      .maybeSingle();

    if (secureRoom && typeof resumeSecureOnlineGame === "function") {
      console.log(t("js.app.012"));
      resumeSecureOnlineGame(secureRoom);
      return;
    }

    // Liegen noch ungespeicherte Tracker-Wuerfe in der Warteschlange
    // (Heatmap-Ingest, offline aufgelaufen), jetzt nachreichen.
    if (typeof flushThrowQueue === "function") flushThrowQueue();
  }

  const adminBtn = document.getElementById("admin-btn");
  if (adminBtn && currentUser && !isGuest) {
    const { data } = await _supabase
      .from("profiles")
      .select("is_admin")
      .eq("id", currentUser.id)
      .maybeSingle();
    adminBtn.style.display = data && data.is_admin ? "block" : "none";
    if (data && data.is_admin) zaehleOffeneNachrichten();
  }

  goHome();
}

/** Unbearbeitete Kontaktnachrichten am Admin-Knopf anzeigen.
 *
 *  Damit sieht ein Admin auf der Startseite, OB sich der Weg ins Panel
 *  lohnt - vorher musste er hineingehen und nachsehen.
 *
 *  Still bei jedem Fehler: Fehlt die Spalte `handled` (Migration
 *  supabase/contact_messages_archiv.sql noch nicht eingespielt) oder
 *  verbietet eine Regel das Lesen, bleibt der Zaehler einfach weg. Ein
 *  Zaehler ist eine Bequemlichkeit; er darf die Startseite nicht mit einer
 *  Fehlermeldung behelligen.
 *
 *  `head: true` holt nur die Anzahl, nicht die Nachrichten selbst - der
 *  Text geht niemanden etwas an, der ihn nicht liest. */
async function zaehleOffeneNachrichten() {
  const marke = document.getElementById("admin-btn-zahl");
  if (!marke || !_supabase) return;
  try {
    const { count, error } = await _supabase
      .from("contact_messages")
      .select("id", { count: "exact", head: true })
      .eq("handled", false);
    if (error || !count) {
      marke.style.display = "none";
      return;
    }
    marke.textContent = String(count);
    marke.style.display = "inline-flex";
  } catch (e) {
    marke.style.display = "none";
  }
}

function goHome() {
  // Nach einem Spiel sollen im Profil frische Zahlen stehen
  if (typeof invalidateProfileCache === "function") invalidateProfileCache();
  document.getElementById("hamburger-btn").style.display = "block";

  hideAllScreens();

  let lobbySetup = document.getElementById("lobby-setup");
  showScreenElement(lobbySetup);
  let lobbyActive = document.getElementById("lobby-active");
  if (lobbyActive) lobbyActive.style.display = "none";

  currentRoomCode = "";
  isOnlineHost = false;

  showScreenElement(document.getElementById("home-screen"));

  // Der Titel wird von einzelnen Modi ueberschrieben; hier - am zentralen
  // Rueckweg ins Hauptmenue - steht er wieder auf dem Namen der Seite.
  // (Das "🧪 TRAINING" des Secure-Trainings, dessentwegen diese Zeilen
  // urspruenglich hier standen, gibt es seit dem 15.08.2026 nicht mehr.)
  const appTitle = document.getElementById("app-title");
  if (appTitle) appTitle.innerText = "SECURE DARTS";

  // Freundesliste im Hauptmenue beim Heimkehren auffrischen
  if (typeof refreshHomeFriendsPanel === "function") refreshHomeFriendsPanel();

  let cancelModal = document.getElementById("cancel-modal");
  if (cancelModal) cancelModal.style.display = "none";

  verlasseSpielzustand();

  // Fortsetzen-Kachel auffrischen (spielwache.js, 29.08.2026): Wer mitten
  // im Spiel heimkehrt, sieht hier den Weg zurueck.
  if (typeof aktualisiereFortsetzenKachel === "function") {
    aktualisiereFortsetzenKachel();
  }
}

// ---------------------------------------------------------------------------
// Spielzustand beim Verlassen zuruecksetzen
//
// BUGFIX 08.08.2026. `isLocal501` wurde beim Start eines lokalen 501 auf
// true gesetzt und danach NIRGENDS zurueck. `submit501Score` ist aber eine
// globale Funktion, und autoscore.js ruft sie bei jedem "cleared" auf -
// in JEDEM Modus. Die einzige Bremse dort ist
//
//     if (!isLocal501 && !isMyTurn) return;
//
// Nach einem lokalen 501 war `isLocal501` weiterhin true, die Bremse also
// offen: Wer danach Cricket startete und die Pfeile zog, liess die
// komplette 501-Logik auf einem unsichtbaren Bildschirm durchlaufen -
// inklusive Aenderung von localP1Score/localP2Score und moeglichem
// Schreiben in die Match-History.
//
// Zurueckgesetzt wird an BEIDEN Uebergaengen: beim Heimkehren und beim
// Betreten eines Modus. Nur goHome() zu nehmen genuegt nicht, weil man
// ueber die Freundesliste direkt von einem Spiel in das naechste springen
// kann, ohne durchs Hauptmenue zu gehen.
// ---------------------------------------------------------------------------
function verlasseSpielzustand() {
  isLocal501 = false;
  isMyTurn = false;
  // Verlassen-Warnung entschaerfen; der gespiegelte Stand BLEIBT liegen -
  // nur ein regulaeres Ende oder "Verwerfen" loescht ihn (spielwache.js).
  if (typeof spielwachePausiert === "function") spielwachePausiert();
  // Auto-Scoring darf keine halbe Aufnahme aus dem vorigen Spiel
  // mitschleppen. reset() leert nur die Pfeile und schliesst den Editor -
  // BEWUSST nicht setActive(false), denn das schaltete das Auto-Scoring ab,
  // und eingeschaltet wird es nur durch ein neues hello. Nach dem ersten
  // Spielwechsel waere es sonst bis zum Trackerneustart tot.
  window.autoScore?.reset?.();
}

function enterMode(mode) {
  verlasseSpielzustand();
  setzeAppModus(mode);
  document.getElementById("home-screen").style.display = "none";
  document.getElementById("hamburger-btn").style.display = "block";

  // Auto-Scoring in den neuen Modus mitnehmen (Adapter-Registry,
  // 13.08.2026): Der Kasten wandert sofort an seine Zielstelle, statt
  // erst mit dem ersten Wurfereignis.
  window.autoScore?.render?.();

  showScreen("play");

  // Setup immer auf dem Lokal-Tab oeffnen und Namen vorbelegen
  if (typeof switchSetupTab === "function") {
    switchSetupTab(mode === "secure" ? "secure" : "501", "local");
  }
  if (typeof applyPlayerNameDefaults === "function") applyPlayerNameDefaults();
}

function showScreen(screenType) {
  hideAllScreens();
  document
    .querySelectorAll(".nav-btn")
    .forEach((b) => b.classList.remove("active"));

  if (screenType === "play") {
    // Frueher stand hier getElementById("tab-play") - das Element gibt es
    // im HTML nicht mehr. Der Aufruf lief dank ?. still ins Leere.
    // Eine Ersatzzuordnung waere geraten: .nav-btn traegt kein Merkmal,
    // das auf "play" zeigt. Deshalb ersatzlos entfernt.
    if (currentAppMode === "secure") {
      const screenId =
        players.length > 0 ? "game-secure-screen" : "secure-setup-screen";
      const el = document.getElementById(screenId);
      showScreenElement(el);
    } else {
      const screenId =
        isLocal501 || currentRoomCode
          ? "game-501-screen"
          : "online-lobby-screen";
      const el = document.getElementById(screenId);
      showScreenElement(el);
    }
  } else if (screenType === "rules") {
    // ("stats" ist entfallen - die Bestenliste ist eine eigene Seite,
    // der Menuepunkt ist ein normaler Link auf stats.html.)
    // dito fuer "tab-rules"
    showScreenElement(document.getElementById("secure-rules-screen"));
  }
}

// ==========================================
// HAUPTMENUE: "Zuletzt gespielt" + eingeklappte Modi (GUI-Plan P1.1)
//
// Nur fuer Smartphones (<=600px): Dort kostet die volle Modus-Liste
// mehrere Bildschirmhoehen Scrollweg. Der zuletzt gespielte Modus wandert
// nach oben, der Rest klappt hinter "Alle Modi anzeigen". Auf dem PC ist
// genug Platz - dort bleibt die Reihenfolge unveraendert und der
// Toggle-Knopf ist per CSS ausgeblendet.
// ==========================================
const LAST_MODE_KEY = "secure-darts:last-mode";
const homeModesMedia = window.matchMedia("(max-width: 600px)");
let homeTilesOriginal = null;

function rememberLastMode(mode) {
  try {
    localStorage.setItem(LAST_MODE_KEY, mode);
  } catch (error) {
    // Gesperrter Speicher - dann eben ohne Merker
  }
}

// Seit der Trennung in Spielen/Training (15.08.2026) gibt es ZWEI Raster.
// Beide werden gleich behandelt, und der zuletzt gespielte Modus wandert an
// den Anfang SEINER Sektion - nicht an den Anfang der Seite. Sonst stuende
// ein Trainingsmodus unter der Ueberschrift "Spielen", also genau dort
// falsch, wo man zuerst hinsieht.
function homeRaster() {
  return Array.from(document.querySelectorAll(".home-modes"));
}

function applyHomeModeOrder() {
  const raster = homeRaster();
  if (!raster.length) return;
  if (!homeTilesOriginal) {
    homeTilesOriginal = raster.map((grid) => ({
      grid,
      tiles: Array.from(grid.querySelectorAll(".tile-btn")),
    }));
  }

  // Immer erst die Original-Reihenfolge herstellen (macht die Funktion
  // idempotent und deckt den Wechsel Mobil -> Desktop ab).
  homeTilesOriginal.forEach(({ grid, tiles }) => {
    tiles.forEach((tile) => {
      tile.classList.remove("is-last-played");
      grid.appendChild(tile);
    });
  });

  if (!homeModesMedia.matches) {
    raster.forEach((grid) => grid.classList.remove("collapsed"));
    return; // PC: alles anzeigen, nichts umsortieren
  }

  let last = null;
  try {
    last = localStorage.getItem(LAST_MODE_KEY);
  } catch (error) {
    last = null;
  }
  if (last) {
    for (const grid of raster) {
      const tile = grid.querySelector(
        `.tile-btn[data-mode="${CSS.escape(last)}"]`,
      );
      if (tile) {
        grid.prepend(tile);
        tile.classList.add("is-last-played");
        break; // eine Kachel, eine Sektion
      }
    }
  }

  raster.forEach((grid) => grid.classList.add("collapsed"));
  const toggle = document.getElementById("btn-more-modes");
  if (toggle) toggle.textContent = t("js.app.010");
}

function toggleMoreModes() {
  const raster = homeRaster();
  if (!raster.length) return;
  // Ein Knopf schaltet BEIDE Sektionen. Zwei unterschiedlich weit
  // aufgeklappte Listen waeren schwerer zu ueberblicken als eine ganze.
  const collapsed = !raster[0].classList.contains("collapsed");
  raster.forEach((grid) => grid.classList.toggle("collapsed", collapsed));
  const toggle = document.getElementById("btn-more-modes");
  if (toggle)
    toggle.textContent = collapsed ? t("js.app.010") : t("js.app.013");
}

// ==========================================
// WIP-BANNER: schliessbar (GUI-Plan P1.2)
// ==========================================
const WIP_KEY = "secure-darts:wip-dismissed";

function applyWipBannerState() {
  const banner = document.querySelector(".wip-banner");
  const mini = document.getElementById("wip-mini-link");
  let dismissed = false;
  try {
    dismissed = localStorage.getItem(WIP_KEY) === "1";
  } catch (error) {
    dismissed = false;
  }
  if (banner) banner.style.display = dismissed ? "none" : "";
  if (mini) mini.style.display = dismissed ? "block" : "none";
}

function dismissWipBanner() {
  try {
    localStorage.setItem(WIP_KEY, "1");
  } catch (error) {}
  applyWipBannerState();
}

function restoreWipBanner() {
  try {
    localStorage.removeItem(WIP_KEY);
  } catch (error) {}
  applyWipBannerState();
  // Sidebar nur schliessen, wenn sie offen ist (der Link steht dort)
  const menu = document.getElementById("main-nav");
  if (menu?.classList.contains("open") && typeof toggleMenu === "function")
    toggleMenu();
}

// DRY Setup Funktionen
function openPartySetup() {
  openGameSetup("party-setup-screen", "PARTY X01", null, "party");
}
function openBobsSetup() {
  openGameSetup("bobs-setup-screen", "BOB'S 27", "bobs-player-input", "bobs");
}
function openRtwSetup() {
  openGameSetup("rtw-setup-screen", "ROUND THE WORLD", "rtw-player-input", "rtw");
}
function open121Setup() {
  // Das Feld heisst player-121-input, nicht setup-121-player-input.
  // Durch den Tippfehler blieb der Spielername bei Catch 121 als
  // einzigem Modus leer.
  openGameSetup("setup-121-screen", "CATCH 121", "player-121-input", "121");
}
function openGotchaSetup() {
  openGameSetup("gotcha-setup-screen", "GOTCHA", "gotcha-player-input", "gotcha");
}

// ==========================================
// FEHLER-TELEMETRIE
//
// Unbehandelte Fehler landen in der Supabase-Tabelle client_errors.
// Ohne diese Sichtbarkeit bleiben Bugs unentdeckt, bis jemand sie meldet.
// Gedrosselt und dedupliziert, damit eine Fehlerschleife nicht die
// Tabelle flutet.
//
// GEAENDERT 08.08.2026: Gaeste koennen jetzt auch melden.
//
// Vorher stand hier `if (isGuest || !currentUser) return;` - und die
// Spalte user_id war NOT NULL. Damit konnten ausgerechnet die Nutzer
// nichts melden, bei denen am ehesten etwas schiefgeht: frisch
// installiert, noch nicht angemeldet, erster Versuch. Die Fehler, die man
// am dringendsten sehen will, waren die einzigen, die nie ankamen.
//
// Die Migration (supabase/02_fix_punkt4.sql) hat user_id nullable
// gemacht und eine Regel ergaenzt, die anonyme Zeilen zulaesst.
// ==========================================
const reportedErrors = new Set();
let errorReportBudget = 10; // max. Meldungen pro Sitzung

const GERAET_SCHLUESSEL = "secure-darts:geraet";

/** Dauerhafte, im Browser erzeugte Geraetekennung.
 *
 * Gruppiert die Meldungen desselben nicht angemeldeten Geraets, ohne eine
 * Person zu benennen: eine Zufalls-UUID, kein Fingerabdruck. Ohne sie
 * waeren Gastmeldungen ein Haufen zusammenhangloser Zeilen - man saehe
 * zehn Fehler und wuesste nicht, ob sie von zehn Leuten stammen oder von
 * einem, der es zehnmal versucht hat. Genau das ist aber der Unterschied
 * zwischen "Randfall" und "niemand kommt rein".
 */
function geraetKennung() {
  try {
    let id = localStorage.getItem(GERAET_SCHLUESSEL);
    if (!id) {
      id = crypto.randomUUID();
      localStorage.setItem(GERAET_SCHLUESSEL, id);
    }
    return id;
  } catch (e) {
    // Privater Modus oder gesperrter Speicher - dann eben ohne
    return null;
  }
}

async function reportClientError(message, source, line, stack) {
  try {
    if (!window._supabase) return;
    if (errorReportBudget <= 0) return;

    const key = `${message}|${source}|${line}`;
    if (reportedErrors.has(key)) return;
    reportedErrors.add(key);
    errorReportBudget--;

    await _supabase.from("client_errors").insert([
      {
        // Angemeldet: das eigene Konto. Gast: null - so verlangt es die
        // RLS-Regel (user_id is null or user_id = auth.uid()).
        user_id: !isGuest && currentUser ? currentUser.id : null,
        geraet_id: geraetKennung(),
        message: String(message || "").slice(0, 500),
        source: String(source || "").slice(0, 300),
        line: Number(line) || null,
        stack: String(stack || "").slice(0, 2000),
        user_agent: String(navigator.userAgent || "").slice(0, 300),
        app_screen: currentAppMode || null,
      },
    ]);
  } catch (e) {
    // Telemetrie darf nie selbst zum Problem werden
  }
}

window.addEventListener("error", (event) => {
  reportClientError(
    event.message,
    event.filename,
    event.lineno,
    event.error && event.error.stack,
  );
});

window.addEventListener("unhandledrejection", (event) => {
  const reason = event.reason;
  reportClientError(
    (reason && reason.message) || String(reason),
    "unhandledrejection",
    null,
    reason && reason.stack,
  );
});

// ==========================================
// TRACKER-SOFTWARE: DOWNLOAD UND VERSIONSHINWEIS
//
// Die Downloadadresse steht NICHT im Code, sondern in /latest.json neben
// der Seite. Grund: Ein neuer Tracker soll ausgeliefert werden koennen,
// ohne dass das Frontend neu gebaut und deployed wird - und die Datei ist
// zugleich die Quelle fuer den Update-Hinweis.
//
// Fehlt die Datei (heute der Fall, solange es keinen Release gibt),
// passiert nichts: Der Knopf bleibt deaktiviert wie bisher.
//
// Aufbau von /latest.json siehe frontend/public/latest.json.
// ==========================================
window.TRACKER_DOWNLOAD_URL = null;
window.TRACKER_LATEST = null;
// Geschlossene Alpha (13.08.2026): Der Download ist an profiles.is_alpha
// gebunden. Ohne Rechte fuehrt der Knopf zum Kontaktformular - der Weg in
// den Test. Die Datei selbst liegt in CLOUDFLARE R2 (der Supabase-Bucket
// scheitert im Free-Tier an 50 MB je Datei, der Installer hat ~180 MB).
// Den Zugang prueft die Edge Function "tracker_download" serverseitig
// (Login + is_alpha) und stellt eine kurzlebige signierte R2-URL aus -
// das Frontend entscheidet nur, was der Knopf anbietet.
window.TRACKER_ALPHA = false;
const TRACKER_LATEST_URL = "/latest.json";

async function ladeTrackerRelease() {
  try {
    const antwort = await fetch(TRACKER_LATEST_URL, { cache: "no-store" });
    if (antwort.ok) {
      const daten = await antwort.json();
      const tracker = daten && daten.tracker;
      // Ein Release existiert, sobald Version und Ablage da sind: oeffentlich
      // ("url", spaeter) oder im Alpha-Bucket ("datei", jetzt).
      if (tracker && (tracker.url || tracker.datei)) {
        window.TRACKER_LATEST = tracker;
        window.TRACKER_DOWNLOAD_URL = tracker.url || null;
      }
    }
  } catch (error) {
    // Kein Release, kein Netz, kaputtes JSON - alles derselbe Fall:
    // Der Knopf zeigt die Alpha-Einladung. Nie ein Spiel stoeren.
  }
  updateTrackerDownloadButton();
  pruefeAlphaRechte();
}

/** Alpha-Rechte des angemeldeten Nutzers nachschlagen (profiles.is_alpha).
 *  Admins zaehlen mit - wer den Test verwaltet, muss ihn laden koennen. */
async function pruefeAlphaRechte() {
  try {
    const { data: { session } = {} } = await _supabase.auth.getSession();
    if (!session) return;
    const { data } = await _supabase
      .from("profiles")
      .select("is_alpha, is_admin")
      .eq("id", session.user.id)
      .single();
    window.TRACKER_ALPHA = !!(data && (data.is_alpha || data.is_admin));
  } catch (error) {
    window.TRACKER_ALPHA = false;
  }
  updateTrackerDownloadButton();
}

/** Vergleicht "0.2.0" mit "0.10.1" richtig - String-Vergleich taete das nicht. */
function versionNeuer(a, b) {
  const zerlege = (v) => String(v || "").split(".").map((t) => parseInt(t, 10) || 0);
  const x = zerlege(a);
  const y = zerlege(b);
  for (let i = 0; i < Math.max(x.length, y.length); i++) {
    if ((x[i] || 0) !== (y[i] || 0)) return (x[i] || 0) > (y[i] || 0);
  }
  return false;
}

/** Darf DIESER Nutzer JETZT laden? Rechte und ein vorhandenes Release. */
function trackerDownloadErlaubt() {
  const release = window.TRACKER_LATEST;
  return !!(window.TRACKER_ALPHA && release
            && (release.datei || window.TRACKER_DOWNLOAD_URL));
}

function updateTrackerDownloadButton() {
  const btn = document.getElementById("btn-download-tracker");
  const hint = document.getElementById("tracker-download-hint");
  const release = window.TRACKER_LATEST;
  // Der Knopf ist IMMER klickbar: ohne Alpha-Rechte fuehrt er zum
  // Kontaktformular - das ist der Weg in den geschlossenen Test.
  if (btn) btn.disabled = false;
  if (!hint) return;

  if (!trackerDownloadErlaubt()) {
    hint.textContent =
      t("js.app.003");
    return;
  }

  // Laeuft bereits ein Tracker und ist er aelter als der Release, ist der
  // Hinweis wichtiger als die Werbung.
  const laufend = window.autoScore?.state?.tracker?.version;
  if (laufend && versionNeuer(release.version, laufend)) {
    hint.textContent =
      tf("js.app.006", { p1: release.version, p2: laufend });
    return;
  }
  if (laufend) {
    hint.textContent = tf("js.app.007", { p1: laufend });
    return;
  }

  const groesse = release.groesse_mb ? ` · ${release.groesse_mb} MB` : "";
  const stand = release.version ? ` ${release.version}` : "";
  hint.textContent = tf("js.app.008", { p1: stand, p2: groesse });
}

async function downloadTrackerSoftware() {
  if (!trackerDownloadErlaubt()) {
    // Geschlossene Alpha: der Weg hinein ist das Kontaktformular.
    window.location.href = "kontakt.html";
    return;
  }
  const release = window.TRACKER_LATEST;
  if (release.datei) {
    // Die Datei liegt in R2. Die Edge Function prueft Login + is_alpha
    // serverseitig und stellt eine 5-Minuten-URL aus - das Frontend kann
    // sie nur anfragen, nicht erzwingen.
    try {
      const { data, error } = await _supabase.functions.invoke(
        "tracker_download",
        { body: { datei: release.datei } },
      );
      if (error || !data?.url) throw error || new Error(t("js.app.004"));
      window.open(data.url, "_blank", "noopener");
    } catch (fehler) {
      showToast(
        t("js.app.005"),
        "info",
      );
    }
    return;
  }
  // Neuer Tab statt Navigation, damit ein laufender Spielstand erhalten bleibt
  window.open(window.TRACKER_DOWNLOAD_URL, "_blank", "noopener");
}

// Einmal beim Laden holen. Danach nochmal, sobald sich ein Tracker meldet -
// erst dann laesst sich "Update verfuegbar" ueberhaupt beantworten.
ladeTrackerRelease();
window.addEventListener("secure-darts:tracker-hello", updateTrackerDownloadButton);

async function requestWakeLock() {
  try {
    if ("wakeLock" in navigator) await navigator.wakeLock.request("screen");
  } catch (err) {}
}

function showCancelModal(actionFunction) {
  pendingCancelAction = actionFunction;
  document.getElementById("cancel-modal").style.display = "flex";
}

function closeCancelModal() {
  document.getElementById("cancel-modal").style.display = "none";
  pendingCancelAction = null;
}

window.addEventListener("DOMContentLoaded", async (event) => {
  // ENTFALLEN 08.08.2026: der Einstieg ?camera=<raum>&role=<rolle>. Er hat
  // die Seite in den Handy-als-Kamera-Modus geschaltet, das UI ausgeblendet
  // und einen LiveKit-Stream aufgebaut. Der ganze Weg ist ausgebaut - siehe
  // Kopf von camera.js. Ein alter QR-Code aus einem geteilten Screenshot
  // laedt damit einfach die normale Seite.

  loadPlayerSuggestions();
  initAuth();
  updateTrackerDownloadButton();

  // "Zuletzt gespielt" (GUI-Plan P1.1): Klick auf eine Modus-Kachel merken,
  // Reihenfolge/Einklappen nur auf Smartphones anwenden.
  document
    .querySelectorAll(".home-modes .tile-btn[data-mode]")
    .forEach((tile) => {
      tile.addEventListener("click", () => rememberLastMode(tile.dataset.mode));
    });
  applyHomeModeOrder();
  homeModesMedia.addEventListener("change", applyHomeModeOrder);
  applyWipBannerState();

  const confirmBtn = document.getElementById("confirm-cancel-btn");
  if (confirmBtn) {
    confirmBtn.onclick = function () {
      if (pendingCancelAction) pendingCancelAction();
      closeCancelModal();
    };
  }
});

// ---------------------------------------------------------------
// Bruecke zu window: Inline-Handler im HTML und andere Module greifen
// weiterhin global auf diese Funktionen zu. Automatisch erzeugt beim
// Umstieg auf Vite - Modul-Scope ersetzt sonst die alten Globals.
// ---------------------------------------------------------------
Object.assign(window, {
  showScreenElement,
  switchToSecureRules,
  hideAllScreens,
  toggleMoreModes,
  applyHomeModeOrder,
  istTrainingsModus,
  setzeAppModus,
  MODUS_GRUPPE,
  dismissWipBanner,
  restoreWipBanner,
  openGameSetup,
  initAuth,
  showAuthScreen,
  showMainApp,
  goHome,
  enterMode,
  showScreen,
  openPartySetup,
  openBobsSetup,
  openRtwSetup,
  open121Setup,
  openGotchaSetup,
  requestWakeLock,
  showCancelModal,
  closeCancelModal,
  setFriendsDockVisible,
  updateTrackerDownloadButton,
  downloadTrackerSoftware,
});
